import React from 'react';
import PropTypes from 'prop-types';

<svg
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.76952 1.7025C9.93072 1.64884 10.102 1.63239 10.2705 1.65438C10.4389 1.67637 10.6002 1.73623 10.7422 1.82947C10.8843 1.92271 11.0033 2.04691 11.0905 2.19274C11.1777 2.33857 11.2307 2.50225 11.2455 2.6715L11.25 2.7705V6.885L14.0955 7.455C14.3327 7.50225 14.5482 7.62465 14.7104 7.80405C14.8725 7.98345 14.9725 8.21031 14.9955 8.451L15 8.5575V14.25H15.75C15.9412 14.2502 16.125 14.3234 16.264 14.4546C16.4031 14.5859 16.4867 14.7652 16.4979 14.956C16.5091 15.1469 16.447 15.3348 16.3243 15.4814C16.2016 15.628 16.0276 15.7222 15.8378 15.7447L15.75 15.75H2.25002C2.05886 15.7498 1.875 15.6766 1.736 15.5454C1.597 15.4141 1.51335 15.2348 1.50214 15.044C1.49094 14.8531 1.55303 14.6652 1.67572 14.5186C1.79841 14.372 1.97245 14.2778 2.16227 14.2552L2.25002 14.25H3.00002V4.77C3.00002 4.32 3.26702 3.918 3.67352 3.7395L3.76952 3.70275L9.76952 1.7025ZM9.75002 3.291L4.50002 5.04075V14.25H9.75002V3.291ZM11.25 8.41575V14.25H13.5V8.865L11.25 8.41575Z"
    fill="#130951"
  />
</svg>;

const Cin = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.76952 1.7025C9.93072 1.64884 10.102 1.63239 10.2705 1.65438C10.4389 1.67637 10.6002 1.73623 10.7422 1.82947C10.8843 1.92271 11.0033 2.04691 11.0905 2.19274C11.1777 2.33857 11.2307 2.50225 11.2455 2.6715L11.25 2.7705V6.885L14.0955 7.455C14.3327 7.50225 14.5482 7.62465 14.7104 7.80405C14.8725 7.98345 14.9725 8.21031 14.9955 8.451L15 8.5575V14.25H15.75C15.9412 14.2502 16.125 14.3234 16.264 14.4546C16.4031 14.5859 16.4867 14.7652 16.4979 14.956C16.5091 15.1469 16.447 15.3348 16.3243 15.4814C16.2016 15.628 16.0276 15.7222 15.8378 15.7447L15.75 15.75H2.25002C2.05886 15.7498 1.875 15.6766 1.736 15.5454C1.597 15.4141 1.51335 15.2348 1.50214 15.044C1.49094 14.8531 1.55303 14.6652 1.67572 14.5186C1.79841 14.372 1.97245 14.2778 2.16227 14.2552L2.25002 14.25H3.00002V4.77C3.00002 4.32 3.26702 3.918 3.67352 3.7395L3.76952 3.70275L9.76952 1.7025ZM9.75002 3.291L4.50002 5.04075V14.25H9.75002V3.291ZM11.25 8.41575V14.25H13.5V8.865L11.25 8.41575Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Cin.propTypes = {
  fill: PropTypes.string,
};

export default Cin;
